/// <reference path="DOMAttached.js" />

class ThemedButton extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.linkElement = document.getElementById(el).querySelector("a");
		this.safeObserve(this.linkElement, 'click', this.onClick.bind(this));
	}

	onClick(ev) {
		ev.preventDefault();
		ev.stopPropagation();

		confirmAI(this.options.trConfirmText, this.onConfirm.bind(this), this.onDelete.bind(this), true, true);
	}

	onConfirm(ev) {
		window.location.href = this.linkElement.href;
	}

	onDelete(ev) {
		// do nothing
	}
}
